import { useCallback, memo } from 'react';
import { noop } from 'lodash';
import styled from 'styled-components';
import { theme } from '../styles/theme.js';
import { jsx } from 'react/jsx-runtime';
const TOGGLER_SIZE = 30;
const TOGGLER_WIDTH = 54;
const TOGGLER_PADDING = 2;
const ANIMATION_TIME = 200;
function Toggler({
  onClick,
  toggled,
  onToggle,
  disabled
}) {
  const handleClick = useCallback(() => {
    if (onClick) onClick();
    if (onToggle) {
      onToggle(!toggled);
    }
  }, [toggled, onToggle, onClick]);
  return /*#__PURE__*/jsx(Container, {
    toggled: toggled,
    onClick: disabled ? noop : handleClick,
    disabled: disabled,
    children: /*#__PURE__*/jsx(Switch, {
      toggled: toggled
    })
  });
}
const Container = styled.div.withConfig({
  shouldForwardProp: p => !['toggled'].includes(p)
})`
  user-select: none;
  -webkit-touch-callout: none;
  cursor: ${({
  disabled
}) => disabled ? 'not-allowed' : 'pointer'};
  width: ${TOGGLER_WIDTH}px;
  position: relative;
  border: 0;
  transition: background-color ${ANIMATION_TIME}ms;
  background-color: ${p => p.toggled ? theme.color.buttonFill : theme.color.accessoryInactive};
  border-radius: ${TOGGLER_SIZE}px;
  height: ${TOGGLER_SIZE}px;
`;
const Switch = styled.div.withConfig({
  shouldForwardProp: p => !['toggled'].includes(p)
})`
  position: absolute;
  top: 2px;
  left: 0;
  background-color: ${theme.color.white};
  text-align: center;
  font-weight: 500;
  box-shadow: ${theme.boxShadow.hover};
  transition: transform ${ANIMATION_TIME}ms;
  width: ${TOGGLER_SIZE - TOGGLER_PADDING * 2}px;
  height: ${TOGGLER_SIZE - TOGGLER_PADDING * 2}px;
  border-radius: ${TOGGLER_SIZE - TOGGLER_PADDING * 2}px;
  transform: translateX(
    ${p => p.toggled ? TOGGLER_WIDTH - TOGGLER_SIZE + TOGGLER_PADDING : TOGGLER_PADDING}px
  );
`;
const Toggler$1 = /*#__PURE__*/memo(Toggler);
export { Container, Toggler$1 as default };
//# sourceMappingURL=Toggler.js.map
